export default __webpack_public_path__ + "static/media/MCTI.d04957d7.svg";